import { Branches, PRINT_DEFAULT_VALUES } from "@/v2/constants";
import PrintBlock from "../base/Block";
import BlockHeading from "../base/Heading";
import BlockRowContent from "../base/RowContent";
import { color } from "../../common";

export default function FromBlock({
    fromHeading,
    formHeadingArabic,
    addressBranch,
}: {
    fromHeading: string;
    formHeadingArabic: string;
    addressBranch: Branches;
}) {
    return (
        <PrintBlock
            style={{
                display: "flex",
                flex: "1",
                backgroundColor: color.bg,
                marginRight: "2px",
                padding: "10px",
                borderRadius: "4px",
            }}
        >
            <BlockHeading
                arabicTitle={formHeadingArabic}
                englishTitle={fromHeading}
            />

            <BlockRowContent
                arabicLabel="الاسم"
                englishLabel="Name"
                content="Abdul Lathif Mohammed Al Refae Est."
                contentInArabic="مؤسسة عبداللطيف محمد سعيد الرفاعي للمقاولات"
                boldContent={true}
            />
            <BlockRowContent
                englishLabel="Address"
                arabicLabel="العنوان"
                content={PRINT_DEFAULT_VALUES.address[addressBranch]}
                contentInArabic={
                    PRINT_DEFAULT_VALUES.arabicAddress[addressBranch]
                }
                style={{ marginBottom: "10px" }}
            />

            <BlockRowContent
                arabicLabel="الرقم الضريبي"
                englishLabel="VAT No"
                content={PRINT_DEFAULT_VALUES.vatNumber}
                disableArabicContent
            />
            <BlockRowContent
                arabicLabel="بريد الالكتروني"
                englishLabel="Email"
                content={PRINT_DEFAULT_VALUES.mail}
                disableArabicContent
            />
            <BlockRowContent
                arabicLabel="السجل التجاري"
                englishLabel="CR No"
                content={PRINT_DEFAULT_VALUES.crNumber[addressBranch]}
                disableArabicContent
            />
        </PrintBlock>
    );
}
